import React, { useEffect, useState } from "react";
import { AvForm } from "availity-reactstrap-validation";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import { Card, CardBody, Col, Container, Button, Row, Label } from "reactstrap";
import SweetAlert from "react-bootstrap-sweetalert";
import Select from "react-select";
import { CircularProgress } from "@material-ui/core";
import ReactQuill from "react-quill";

const AddCarparkModal = (props) => {
  const statusOptions = [
    { value: "Y", label: "Enable" },
    { value: "N", label: "Disable" },
  ];

  const rewardTypeOptions = [
    { value: "All", label: "All" },
    { value: "Redeem", label: "Redeem" },
    { value: "Purchase", label: "Purchase" },
  ];

  const rewardCategoryOptions = [
    { value: "All Reward", label: "All Reward" },
    { value: "Carpark$", label: "Carpark$" },
    { value: "Line Friends", label: "Line Friends" },
    { value: "Eat & Drink", label: "Eat & Drink" },
    { value: "Shop & Play", label: "Shop & Play" },
    { value: "Everything Else", label: "Everything Else" },
    { value: "Gift Cards", label: "Gift Cards" },
  ];

  const [rewardType, setRewardType] = useState("");
  const [rewardCategory, setRewardCategory] = useState("");
  const [confirmationMessage, setConfirmationMessage] = useState("");
  const [purchaseMessage, setPurchaseMessage] = useState("");
  const [status, setStatus] = useState(statusOptions[0].value);
  const [successAlert, setSuccesAlert] = useState(false);
  const [errorAlert, setErrorAlert] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [token, setToken] = useState();
  const [propsData, setPropsData] = useState(props?.location?.state);
  const [loader, setLoader] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem("AuthenticationToken");
    setToken(token);

    if (props.location?.state?.edit && props.location?.state?.item) {
      setPropsData(props?.location?.state);
      var rewardType = props.location.state?.item?.reward_type;
      var rewardCategory = props.location.state?.item?.reward_category;
      var confirmationMessage = props.location.state?.item?.confirmation_message;
      var purchaseMessage = props.location.state?.item?.purchase_message;
      var status = props.location.state?.item?.status;
      setRewardType(rewardType || "");
      setRewardCategory(rewardCategory || "");
      setConfirmationMessage(confirmationMessage || "");
      setPurchaseMessage(purchaseMessage || "");
      setStatus(status);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleSubmit = () => {
    if (!rewardType) {
      setErrorMessage("Please select reward type");
      setErrorAlert(true);
      return;
    } else if (!rewardCategory) {
      setErrorMessage("Please select reward category");
      setErrorAlert(true);
      return;
    } else if (!checkTextInsideHtml(confirmationMessage)) {
      setErrorMessage("Please enter confirmation message");
      setErrorAlert(true);
      return;
    } else if (!checkTextInsideHtml(purchaseMessage)) {
      setErrorMessage("Please enter purchase message");
      setErrorAlert(true);
      return;
    } else if (!status) {
      setErrorMessage("Please select status");
      setErrorAlert(true);
      return;
    }

    setLoader(true);
    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);
    myHeaders.append("cache-control", "no-cache");
    myHeaders.append(
      "Cookie",
      "__cfduid=d5b74235daa6f013fde0aba762ec288811620640208"
    );

    var formdata = new FormData();
    formdata.append("reward_type", rewardType);
    formdata.append("reward_category", rewardCategory);
    formdata.append("show_my_reward", "1");
    formdata.append("confirmation_message", confirmationMessage);
    formdata.append("purchase_message", purchaseMessage);
    formdata.append("status", status);

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: formdata,
      redirect: "follow",
      processData: false,
      mimeType: "multipart/form-data",
      async: true,
      crossDomain: true,
    };

    fetch(`${process.env.REACT_APP_TOKRI_API_URL}/api/carparkmodal`, requestOptions)
      .then((response) => {
        if (response.status === 201) {
          setSuccesAlert(true);
          setLoader(false);
        } else {
          setErrorMessage("Unable to Add");
          setErrorAlert(true);
          setLoader(false);
        }
        response.json();
      })
      .catch((error) => {
        console.log("here come error--->", error);
        setErrorMessage("Error occurred while adding");
        setErrorAlert(true);
        setLoader(false);
      });
  };

  const handleEdit = () => {
    if (!rewardType) {
      setErrorMessage("Please select reward type");
      setErrorAlert(true);
      return;
    } else if (!rewardCategory) {
      setErrorMessage("Please select reward category");
      setErrorAlert(true);
      return;
    } else if (!checkTextInsideHtml(confirmationMessage)) {
      setErrorMessage("Please enter confirmation message");
      setErrorAlert(true);
      return;
    } else if (!checkTextInsideHtml(purchaseMessage)) {
      setErrorMessage("Please enter purchase message");
      setErrorAlert(true);
      return;
    } else if (!status) {
      setErrorMessage("Please select status");
      setErrorAlert(true);
      return;
    }

    setLoader(true);
    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);
    myHeaders.append("cache-control", "no-cache");
    myHeaders.append(
      "Cookie",
      "__cfduid=d5b74235daa6f013fde0aba762ec288811620640208"
    );

    var formdata = new FormData();
    formdata.append("id", propsData?.item?.id);
    formdata.append("_method", "put");
    formdata.append("reward_type", rewardType);
    formdata.append("reward_category", rewardCategory);
    formdata.append("show_my_reward", "1");
    formdata.append("confirmation_message", confirmationMessage);
    formdata.append("purchase_message", purchaseMessage);
    formdata.append("status", status);

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: formdata,
      redirect: "follow",
      processData: false,
      mimeType: "multipart/form-data",
      async: true,
      crossDomain: true,
    };

    fetch(`${process.env.REACT_APP_TOKRI_API_URL}/api/carparkmodal/update`, requestOptions)
      .then((response) => {
        if (response.status === 200) {
          setSuccesAlert(true);
          setLoader(false);
        } else {
          setErrorMessage("Unable to Update");
          setErrorAlert(true);
          setLoader(false);
        }
      })
      .catch((error) => {
        console.log("here come error--->", error);
        setErrorMessage("Error occurred while updating");
        setErrorAlert(true);
        setLoader(false);
      });
  };

  const renderSuccessAlert = () => {
    return (
      <SweetAlert
        title="Success!"
        success
        confirmBtnBsStyle="success"
        beforeUnmount={() => {
          props?.history.push("/rewardsmodal");
          setSuccesAlert(false);
        }}
        onConfirm={() => {
          props?.history.push("/rewardsmodal");
          setSuccesAlert(false);
        }}
        onCancel={() => {
          setSuccesAlert(false);
        }}
      >
        {props.location?.state?.edit
          ? "Rewards Modal updated"
          : "Rewards Modal created"}
      </SweetAlert>
    );
  };

  const renderFailureAlert = () => {
    return (
      <SweetAlert
        title="Warning!"
        warning
        confirmBtnBsStyle="warning"
        onConfirm={() => {
          setErrorAlert(false);
        }}
      >
        {errorMessage ? errorMessage : "Error. Something went wrong."}
      </SweetAlert>
    );
  };

  const checkTextInsideHtml = (htmlString) => {
    const regex = /<[^>]+>([^<]+)<\/[^>]+>/;
    const matchBookingInfo = regex.exec(htmlString);    
    if (matchBookingInfo && matchBookingInfo[1]) {
      return true;
    } else {
      const simpleStringRegex = /^[^<>\n]+$/;
      return simpleStringRegex.test(htmlString);
    }
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs breadcrumbItem={props.location?.state?.edit ? "Edit Rewards Modal" : "Add Rewards Modal"} />
          <Row>
            <Col lg={12}>
              <Card>
                <CardBody>
                  <AvForm className="needs-validation">
                    <Card>
                      <CardBody>
                        <Row>
                          <Col md={4}>
                            <Row>
                              <Col md={12}>
                                <div className="mb-3">
                                  <Label>Reward Type</Label>
                                  <Select
                                    onChange={(e) => {
                                      setRewardType(e.value);
                                    }}
                                    options={rewardTypeOptions}
                                    placeholder="Choose..."
                                    value={rewardType ? rewardTypeOptions.find(option => option.value === rewardType) : null}
                                  />
                                </div>
                              </Col>
                              <Col md={12}>
                                <div className="mb-3">
                                  <Label>Reward Category</Label>
                                  <Select
                                    onChange={(e) => {
                                      setRewardCategory(e.value);
                                    }}
                                    options={rewardCategoryOptions}
                                    placeholder="Choose..."
                                    value={rewardCategory ? rewardCategoryOptions.find(option => option.value === rewardCategory) : null}
                                  />
                                </div>
                              </Col>
                            </Row>
                          </Col>
                        </Row>
                      </CardBody>
                    </Card>
                    <Card>
                      <CardBody>
                        <Row>
                          <Col md={4}>
                            <div className="mb-3">
                              <Label>Confirmation Message</Label>
                              <ReactQuill
                                modules={{
                                  toolbar: [
                                    ["bold", "italic", "underline"],
                                    [{ list: "ordered" }, { list: "bullet" }],
                                    ["link", { color: [] }],
                                    ["clean"],
                                  ],
                                }}
                                theme="snow"
                                value={confirmationMessage}
                                onChange={(e) => {
                                  setConfirmationMessage(e);
                                }}
                                style={{ minHeight: "30px" }}
                              />
                            </div>
                          </Col>
                          <Col md={4}>
                            <div className="mb-3">
                              <Label>Purchase Message</Label>
                              <ReactQuill
                                modules={{
                                  toolbar: [
                                    ["bold", "italic", "underline"],
                                    [{ list: "ordered" }, { list: "bullet" }],
                                    ["link", { color: [] }],
                                    ["clean"],
                                  ],
                                }}
                                theme="snow"
                                value={purchaseMessage}
                                onChange={(e) => {
                                  setPurchaseMessage(e);
                                }}
                                style={{ minHeight: "30px" }}
                              />
                            </div>
                          </Col>
                        </Row>
                      </CardBody>
                    </Card>
                    <Card>
                      <CardBody>
                        <Row>
                          <Col md={4}>
                            <div className="mb-3">
                              <Label>Status</Label>
                              <Select
                                onChange={(e) => {
                                  setStatus(e.value);
                                }}
                                options={statusOptions}
                                placeholder={
                                  status
                                    ? status === "Y"
                                      ? "Enable"
                                      : "Disable"
                                    : "Choose..."
                                }
                                defaultValue={status}
                                required
                              />
                            </div>
                          </Col>
                        </Row>
                      </CardBody>
                    </Card>
                    <div style={{ textAlign: "right" }} className="btn-sec">
                      <Button
                        onClick={() => {
                          props.history.goBack();
                        }}
                        color="danger"
                        type="submit"
                      >
                        Cancel
                      </Button>
                      <button
                        disabled={loader}
                        style={{
                          color: "#ffffff",
                          width: "80px",
                          marginLeft: "10px",
                        }}
                        className={"btn btn-success"}
                        onClick={() => {
                          if (props?.location?.state?.edit) {
                            handleEdit();
                          } else {
                            handleSubmit();
                          }
                        }}
                        color="success"
                        type="submit"
                      >
                        {loader ? (
                          <CircularProgress
                            size={15}
                            value={100}
                            color={"white"}
                          />
                        ) : (
                          "Save"
                        )}
                      </button>
                    </div>
                  </AvForm>
                </CardBody>
              </Card>
            </Col>
          </Row>
          {successAlert ? renderSuccessAlert() : null}
          {errorAlert ? renderFailureAlert() : null}
        </Container>
      </div>
    </React.Fragment>
  );
};

export default AddCarparkModal;

